import { createContext, SetStateAction, useContext } from 'react';
import { QualioDocument } from '../../../api/model/document';
import { Tag } from '../../../api/model/tag';
import { MedtechUserV2 } from '../../../api/user';
import {
  ChangeControl,
  ChangeControlWithTemplate,
} from '../../../types/DocumentCreate';
import { EditorMode } from '../../../util/EditModeUtils';

export type DocumentOverviewContextType = {
  qualioDocument: QualioDocument;
  changeControl: ChangeControl;
  changeControlWithTemplate?: ChangeControlWithTemplate;
  currentEditorMode: EditorMode;
  collaborationToken: string;
  commentsPermission: number;
  refetchDocumentOverviewData: (fetchLatestVersion?: boolean) => void;
  refetchChangeControl?: () => void;
  updateEditorMode: (mode: EditorMode) => void;
  users?: MedtechUserV2[];
  tags?: Tag[];
  widthRef?: React.RefObject<HTMLDivElement>;
};

export const DocumentOverviewContext =
  createContext<DocumentOverviewContextType>({} as any);

export const useDocumentOverviewContext = () =>
  useContext(DocumentOverviewContext);

export enum EditorStatus {
  CONNECTING,
  STABLE,
  SAVING,
  SAVED,
  ERROR,
  PENDING_AUTOSAVE,
}

export type EditorStatusContextType = {
  docEditorStatus: EditorStatus;
  ccEditorStatus: EditorStatus;
  trainingAssessmentStatus: EditorStatus;
  setCCEditorStatus: React.Dispatch<SetStateAction<EditorStatus>>;
  setDocEditorStatus: React.Dispatch<SetStateAction<EditorStatus>>;
  setTrainingAssessmentStatus: React.Dispatch<SetStateAction<EditorStatus>>;
};

export const EditorStatusContext = createContext<EditorStatusContextType>(
  {} as any,
);

export interface ZoomContextType {
  scale: number;
  setScale: (scale: number) => void;
}

export const ZoomContext = createContext<ZoomContextType | undefined>(
  undefined,
);
